import { attemptMethod } from "@utils/general";

const LEFT = "<!--";
const RIGHT = "-->";

const parseElementForCommentedContent = (element: HTMLElement | null) => {
    if (!element) {
        return undefined;
    }
    return attemptMethod(() => {
        const payload = element.innerHTML;
        const jsonPayload = payload.slice(
            LEFT.length,
            payload.length - RIGHT.length,
        );
        return JSON.parse(jsonPayload);
    }, {});
};

export { parseElementForCommentedContent };
